import React, {Component} from 'react';
import _ from 'lodash';
import Footer from './Footer';
import Collapse from './Collapse';
import About from './About';
import Contact from './Contact';
import Projects from './Projects';
import './Page.css';


class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      about: null,
      contact: null,
      gallery: null,
      loaded: false,
    }
  }

  componentDidMount() {
    this.fetchPage(this.props);
  }

  componentWillReceiveProps(props) {
    if(!this.state.loaded) this.fetchPage(props);
  }

  fetchPage(props) {
    if (props.prismicCtx) {
      props.prismicCtx.api.query('', (err,doc) => {
        let about = _.find(doc.results, { 'type': 'about' });
        let contact = _.find(doc.results, { 'type': 'contact' });
        let gallery = _.find(doc.results, { 'type': 'gallery' });
        let projects = _.filter(doc.results, { 'type': 'project' });
        gallery.singleProject = projects;
        console.log(contact);
        this.setState({about, contact, gallery, loaded: true });
      });
    }
  }

  render(){
    let {about, contact, gallery, loaded} = this.state;
    return (
      <div className="Page">
        <Collapse header="About">
          { loaded && <About doc={about} /> }
        </Collapse>
        <Collapse header="Contact">
          { loaded && <Contact doc={contact} /> }
        </Collapse>
        { loaded && <Projects doc={gallery} /> }
        { loaded &&  <Footer instragram={contact.data.instagram}/> }
      </div>
    )
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/components/Page.js